
import * as handlebars_family from "../handlebars_family.js";

const TPL = handlebars_family.addTemplate("budget/budget_empty",{"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<flexcenter style=\"height:100%\"><div class=\"content\" style=\"text-align:center;max-width:300px;margin-bottom:48px;\"><div class=\"budget-empty\"></div><h1>"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"budget.empty.title",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":151},"end":{"line":1,"column":182}}})) != null ? stack1 : "")
    + "</h1><p class=\"blockmargin\" style=\"color:#888;\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"budget.empty.text",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":230},"end":{"line":1,"column":260}}})) != null ? stack1 : "")
    + "</p><button style=\"width:fit-content;\" data-fw-onclick=\"budgetcreate\"> "
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"budget.empty.button",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":331},"end":{"line":1,"column":363}}})) != null ? stack1 : "")
    + " </button></div></flexcenter>";
},"useData":true});
export default TPL;